import { UNKNOWN_VALUE } from '../constants'

const ID_PLACEHOLDER = '{id}'

const NUMERIC_SEGMENT = /^\d+$/
const UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

const safePathname = (url: string): string => {
  try {
    return new URL(url).pathname
  } catch {
    return url
  }
}

const toFingerprintPath = (url: string): string => {
  const path = url.startsWith('http') ? safePathname(url) : url

  return path
    .split('?')[0]
    .split('/')
    .map(segment =>
      NUMERIC_SEGMENT.test(segment) || UUID_SEGMENT.test(segment)
        ? ID_PLACEHOLDER
        : segment
    )
    .join('/')
}

type TFailureLabel = 'timeout' | 'network'

interface IFingerprintParams {
  source: 'axios' | 'serverHttp'
  method: string
  url: string
  status?: number
  failure?: TFailureLabel
}

export const buildFingerprint = ({
  source,
  method,
  url,
  status,
  failure = 'network',
}: IFingerprintParams): string =>
  `${source}:${method || UNKNOWN_VALUE}:${toFingerprintPath(url)}:${status ?? failure}`
